import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { map_navigation } from './config.js';
import Details from './Details';
//import ReCAPTCHA from "react-google-recaptcha"
import CommonFile from './images/CommonFile.svg';
import DocFile from './images/DocFile.svg';
import ExcelFile from './images/ExcelFile.svg';
import MediaFile from './images/MediaFile.svg';
import PdfFile from './images/PdfFile.svg';
import PresentationFile from './images/PresentationFile.svg';

import Reaptcha from 'reaptcha';
import RequestLocation from './components/RequestLocation.js';

const organizationName = process.env.REACT_APP_ORGANIZATION_NAME;
const gmapApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
const catpchaKey = process.env.REACT_APP_GOOGLE_CAPTCHA_API_KEY;

//Endpoints
const serviceAreaEndpoint = process.env.REACT_APP_FETCH_SERVICE_AREA;
const requestTypesEndpoint = process.env.REACT_APP_FETCH_REQUEST_TYPES;
const postToSharePointEndpoint = process.env.REACT_APP_POST_TO_SHAREPOINT;
const showMap = process.env.REACT_APP_SHOW_MAP !== 'false';

const trimText = (text, maxLength) => {
  if (text) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  }
  return text;
};

const fileIcons = {
  'application/msword': DocFile,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    DocFile,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
    DocFile,
  'application/vnd.ms-word.document.macroEnabled.12': DocFile,
  'application/vnd.ms-word.template.macroEnabled.12': DocFile,
  'text/rtf': DocFile,
  'text/plain': DocFile,
  'text/html': DocFile,
  'application/vnd.oasis.opendocument.text': DocFile,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    ExcelFile,
  'application/vnd.ms-excel': ExcelFile,
  'application/vnd.ms-excel.sheet.macroEnabled.12': ExcelFile,
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12': ExcelFile,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
    ExcelFile,
  'application/vnd.ms-excel.template.macroEnabled.12': ExcelFile,
  'text/csv': ExcelFile,
  'application/vnd.oasis.opendocument.spreadsheet': ExcelFile,
  'application/xml': ExcelFile,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    PresentationFile,
  'application/vnd.ms-powerpoint': PresentationFile,
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
    PresentationFile,
  'application/vnd.openxmlformats-officedocument.presentationml.template':
    PresentationFile,
  'application/vnd.ms-powerpoint.template.macroEnabled.12': PresentationFile,
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': PresentationFile,
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
    PresentationFile,
  'video/mp4': MediaFile,
  'video/x-msvideo': MediaFile,
  'video/x-matroska': MediaFile,
  'video/quicktime': MediaFile,
  'video/x-ms-wmv': MediaFile,
  'video/x-flv': MediaFile,
  'video/mpeg': MediaFile,
  'video/x-m4v': MediaFile,
  'video/webm': MediaFile,
  'video/3gpp': MediaFile,
  'audio/mpeg': MediaFile,
  'audio/wav': MediaFile,
  'audio/ogg': MediaFile,
  'audio/aac': MediaFile,
  'audio/flac': MediaFile,
  'audio/x-ms-wma': MediaFile,
  'audio/m4a': MediaFile,
  'audio/alac': MediaFile,
  'audio/aiff': MediaFile,
  'audio/midi': MediaFile,
  'application/pdf': PdfFile,
};

const MyForm = () => {
  let yellow = '#212b36';
  let re_token = '';
  const [bgColor, setBgColor] = useState(yellow);
  const changeColor = () => {
    let purple = yellow;
    setBgColor(purple);
  };
  let capatcha_token = null;
  const mapRef = useRef(null);
  const [formData, setFormData] = useState(null);
  const photoInputRef = useRef(null);
  const addressInputRef = useRef(null);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [serviceAreas, setServiceAreas] = useState([]);
  const [requestTypes, setrequestTypes] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [captchaToken, setCaptchaToken] = useState('');
  const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);

  const captchaRef = useRef(null);
  const verify = () => {
    captchaRef.current.getResponse().then((res) => {
      setCaptchaToken(res);
    });
  };
  const onExpire = () => {
    setCaptchaToken('');
  };
  const checkEnvVariables = () => {
    const missingVariables = [];

    if (!organizationName) missingVariables.push('REACT_APP_ORGANIZATION_NAME');
    if (!gmapApiKey) missingVariables.push('REACT_APP_GOOGLE_MAP_API_KEY');
    if (!catpchaKey) missingVariables.push('REACT_APP_GOOGLE_CAPTCHA_API_KEY');
    if (!serviceAreaEndpoint)
      missingVariables.push('REACT_APP_FETCH_SERVICE_AREA');
    if (!requestTypesEndpoint)
      missingVariables.push('REACT_APP_FETCH_REQUEST_TYPES');
    if (!postToSharePointEndpoint)
      missingVariables.push('REACT_APP_POST_TO_SHAREPOINT');

    return missingVariables;
  };

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      if (window.google && window.google.maps) {
        setIsGoogleLoaded(true);
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${gmapApiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => setIsGoogleLoaded(true);
      document.head.appendChild(script);
    };

    loadGoogleMapsScript();
  }, []);

  useEffect(() => {
    if (!isGoogleLoaded || !mapRef.current) return;
    let map, marker;
    const handleImagePreview = () => {
      const files = Array.from(photoInputRef.current.files);

      const allowedFormats = [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroEnabled.12',
        'application/vnd.ms-word.template.macroEnabled.12',
        'text/rtf',
        'text/plain',
        'text/html',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'application/vnd.ms-excel.sheet.macroEnabled.12',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.template.macroEnabled.12',
        'text/csv',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/xml',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-powerpoint',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.ms-powerpoint.template.macroEnabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/bmp',
        'image/tiff',
        'image/svg+xml',
        'image/x-icon',
        'image/webp',
        'video/mp4',
        'video/x-msvideo',
        'video/x-matroska',
        'video/quicktime',
        'video/x-ms-wmv',
        'video/x-flv',
        'video/mpeg',
        'video/x-m4v',
        'video/webm',
        'video/3gpp',
        'audio/mpeg',
        'audio/wav',
        'audio/ogg',
        'audio/aac',
        'audio/flac',
        'audio/x-ms-wma',
        'audio/m4a',
        'audio/alac',
        'audio/aiff',
        'audio/midi',
        'application/pdf',
      ];

      const invalidFiles = files.filter(
        (file) => !allowedFormats.includes(file.type)
      );
      if (invalidFiles.length > 0) {
        setErrorMessage(
          'Invalid file format. Please upload only image files (JPG, JPEG, or PNG).'
        );
        setIsSubmitDisabled(true);
        setImagePreviews([]); // Clear image previews since an invalid file was selected
        return;
      }

      if (files.length > 7) {
        setErrorMessage('You can only select a maximum of 7 files.');
        setIsSubmitDisabled(true);
        return;
      }

      const allowedSize = 3000 * 1024; // 3MB
      const invalidSizeFiles = files.filter((file) => file.size > allowedSize);

      if (invalidSizeFiles.length > 0) {
        setErrorMessage(
          'File size limit exceeded. Please select files up to 3MB.'
        );
        setIsSubmitDisabled(true);
        return;
      }

      setErrorMessage('');
      setIsSubmitDisabled(false);

      const newPreviews = files.map((file) => {
        const isImage = file.type.startsWith('image/');
        if (isImage) {
          return {
            isImage: true,
            name: file.name,
            preview: URL.createObjectURL(file),
          };
        }

        const iconSrc = fileIcons[file.type] || CommonFile;
        return {
          isImage: false,
          name: file.name,
          preview: iconSrc,
        };
      });

      setImagePreviews(newPreviews);

      setSelectedFiles(files);
    };
    photoInputRef.current.addEventListener('change', handleImagePreview);
    const initMap = () => {
      if (!window.google || !window.google.maps) {
        console.error('Google Maps API is not available');
        return;
      }
      const initialLocation = {
        lat: map_navigation.lat,
        lng: map_navigation.lng,
      }; // Initial map center coordinates (Manila, PH)

      map = new window.google.maps.Map(mapRef.current, {
        center: initialLocation,
        zoom: 8,
        apiKey: gmapApiKey,
      });

      marker = new window.google.maps.Marker({
        map: map,
        draggable: true,
      });

      // Add event listener to update marker position and address when the marker is dragged
      window.google.maps.event.addListener(marker, 'dragend', function () {
        updateMarkerPosition(marker.getPosition());
        geocodeLatLng(marker.getPosition());
      });

      // Add event listener to update marker position and address when the map is clicked
      window.google.maps.event.addListener(map, 'click', function (event) {
        marker.setPosition(event.latLng);
        updateMarkerPosition(event.latLng);
        geocodeLatLng(event.latLng);
      });

      const geocoder = new window.google.maps.Geocoder();

      // Add event listener to update marker position and address when the marker is clicked
      window.google.maps.event.addListener(marker, 'click', function () {
        const position = marker.getPosition();

        // Reverse geocode the marker's position to get the address details
        geocoder.geocode({ location: position }, function (results, status) {
          if (status === 'OK' && results[0]) {
            const clickedResult = results[0];

            // Find the building name component in the address details
            const buildingNameComponent = clickedResult.address_components.find(
              (component) => component.types.includes('premise')
            );

            // Use the building name if available, otherwise use the formatted address
            const clickedBuildingName = buildingNameComponent
              ? buildingNameComponent.long_name
              : clickedResult.formatted_address;

            // Update the address input value with the clicked building name
            addressInputRef.current.value = clickedBuildingName;
          }
        });
      });

      addressInputRef.current.addEventListener('input', handleAddressInput);
    };

    const handleAddressInput = () => {
      const address = addressInputRef.current.value;
      geocodeAddress(address);
    };

    const updateMarkerPosition = (latLng) => {
      document.getElementById('latitude').value = latLng.lat();
      document.getElementById('longitude').value = latLng.lng();
      map.setCenter(latLng);
      map.setZoom(16);
    };

    const geocodeLatLng = (latLng) => {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: latLng }, function (results, status) {
        if (status === 'OK' && results[0]) {
          document.getElementById('address').value =
            results[0].formatted_address;
        }
      });
    };
    const geocodeAddress = (address) => {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address }, function (results, status) {
        if (status === 'OK' && results[0]) {
          const location = results[0].geometry.location;
          marker.setPosition(location);
          updateMarkerPosition(location);
        }
      });
    };

    initMap();
  }, [isGoogleLoaded]);

  useEffect(() => {
    const fetchServiceAreas = async () => {
      try {
        //const response = await fetch(url.main + "/getServiceArea");
        const response = await fetch(serviceAreaEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch service areas');
        }
        const data = await response.json();
        //console.log(data);
        setServiceAreas(data);
      } catch (error) {
        console.log('Error fetching service areas:', error);
      }
    };
    fetchServiceAreas();
  }, []);

  useEffect(() => {
    const fetchRequesttypes = async () => {
      try {
        const responseType = await fetch(requestTypesEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!responseType.ok) {
          throw new Error('Failed to fetch request types');
        }
        const data = await responseType.json();

        setrequestTypes(data);
      } catch (error) {
        console.log('Error fetching request types:', error);
      }
    };
    fetchRequesttypes();
  }, []);

  const handleImageRemove = (index) => {
    const updatedPreviews = [...imagePreviews];
    updatedPreviews.splice(index, 1);
    setImagePreviews(updatedPreviews);

    // Remove the corresponding selected file
    const updatedSelectedFiles = [...selectedFiles];
    updatedSelectedFiles.splice(index, 1);
    setSelectedFiles(updatedSelectedFiles);

    setIsSubmitDisabled(false); // Enable the submit button after removing an image
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission
    setIsSubmitDisabled(true); // Disable the submit button to prevent multiple submissions
    setIsSubmitted(true);

    // Retrieve token
    //const token = "1234567"; // Replace with actual token retrieval logic
    const token = document.getElementById('re-token').value;

    if (!token) {
      document.getElementById('error_message').style.visibility = 'visible';
      return;
    }

    // Retrieve form data
    const [serviceAreas, user_id] =
      event.target.elements.serviceArea.value.split('|');
    const name = event.target.elements.name.value;
    const email = event.target.elements.email.value;
    const phone = event.target.elements.phone.value;
    const requestDesc = event.target.elements.requestDesc.value;

    const serviceAreaElement = event.target.elements.serviceArea;
    const serviceArea =
      serviceAreaElement.options[serviceAreaElement.selectedIndex].text;

    const requestTypeElement = event.target.elements.requestType;
    const requestType =
      requestTypeElement.options[requestTypeElement.selectedIndex].text;

    const title = event.target.elements.title.value;
    const address = event.target.elements.address?.value || null;
    const latitude = event.target.elements.latitude?.value || null;
    const longitude = event.target.elements.longitude?.value || null;

    let files = []; // Array to hold processed file objects

    try {
      // Process all files using Promise.all
      await Promise.all(
        selectedFiles.map((file) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              files.push({
                fileName: file.name,
                fileContent: event.target.result.split(',')[1], // Extract Base64 content
              });
              resolve(); // Resolve the promise after processing
            };
            reader.onerror = () =>
              reject(new Error(`Error reading file: ${file.name}`));
            reader.readAsDataURL(file); // Read file as Base64
          });
        })
      );

      // Construct the data object
      let data = {
        name,
        email,
        phone: parseInt(phone, 10),
        title,
        serviceArea,
        requestType,
        description: requestDesc,
        files,
        latitude: Number(latitude),
        longitude: Number(longitude),
        address,
      };

      //console.log("Constructed Data:", data);

      // API configuration
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: postToSharePointEndpoint,
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      };

      setIsLoading(true); // Show loading indicator

      // Send the API request
      const response = await axios.request(config);

      if (response.status >= 200 && response.status < 300) {
        // Form submitted successfully
        setFormData({
          name,
          email,
          phone,
          requestType,
          requestDesc,
          serviceArea,
          title,
          address,
          latitude,
          longitude,
          selectedFiles,
          user_id,
        });
        console.log('Form submitted successfully:', response.data);
      } else {
        throw new Error('Failed to submit the form');
      }
    } catch (error) {
      console.error('Error during form submission:', error);
      captchaRef.current.reset(); // Reset CAPTCHA on error
    } finally {
      setIsLoading(false); // Hide loading indicator
      setIsSubmitDisabled(false); // Re-enable submit button
    }
  };
  console.log({ serviceAreas });
  const missingVariables = checkEnvVariables();
  return (
    <>
      {missingVariables.length > 0 ? (
        <div style={{ color: 'red', padding: '10px', border: '1px solid red' }}>
          <h3>Error: Missing Environment Variables</h3>
          <ul>
            {missingVariables.map((variable, index) => (
              <li key={index}>{variable}</li>
            ))}
          </ul>
        </div>
      ) : (
        ''
      )}
      <div className="form-container">
        {formData ? (
          <Details formData={formData} />
        ) : (
          <form
            id="myForm"
            onSubmit={handleSubmit}
            encType="multipart/form-data"
          >
            <div className="container">
              {
                <img
                  className="leftimg"
                  alt="RequestHQ_logo"
                  src="/Agendis_Request1.png"
                  style={{ height: '25px' }}
                />
              }
            </div>
            <div className="line"></div>
            <h1>Send a Request</h1>
            <h2>Requester Information</h2>
            <label>
              <span class="name-label">Name </span>
              <span class="required-asterisk">*</span>
            </label>
            <input type="text" id="name" name="name" required />
            <label>
              <span class="name-label">Email </span>
              <span class="required-asterisk">*</span>
            </label>
            <input type="email" id="email" name="email" required />
            <label>
              <span class="name-label">Phone </span>
            </label>
            <input type="tel" id="phone" name="phone" />
            <h2>Request Details</h2>
            <label>
              <span class="name-label">Title </span>
              <span class="required-asterisk">*</span>
            </label>
            <input
              type="text"
              id="title"
              maxlength="100"
              name="title"
              required
            />
            <label>
              <span class="name-label">Service Area </span>
              <span class="required-asterisk">*</span>
            </label>
            <select id="serviceArea" name="serviceArea">
              <option value=""></option>
              {serviceAreas.map((area) => (
                <option key={area.id} value={`${area.id}|${area.user_id}`}>
                  {area.title}
                </option>
              ))}
            </select>
            <label>
              <span class="name-label">Request Type </span>
              <span class="required-asterisk">*</span>
            </label>
            <select id="requestType" name="requestType">
              <option value=""></option>
              {requestTypes.map((area) => (
                <option key={area.id} value={area.id}>
                  {area.title}
                </option>
              ))}
            </select>
            <label>
              <span class="name-label">Description </span>
              <span class="required-asterisk">*</span>
            </label>
            <textarea
              type="text"
              id="requestDesc"
              maxlength="1000"
              name="requestDesc"
              required
            />
            <h2 id="attach">Attach Files/Photos</h2>
            <input
              type="file"
              id="photos"
              name="photos"
              multiple
              ref={photoInputRef}
            />
            <div style={{ color: 'red' }}>{errorMessage}</div>{' '}
            {/* Display error message */}
            <div id="attachments">
              {imagePreviews.map((preview, index) => (
                <div key={index} style={{ position: 'relative' }}>
                  {preview.isImage === true ? (
                    <div>
                      <div
                        style={{
                          width: '160px',
                          marginTop: '20px',
                          marginLeft: '30px',
                        }}
                      >
                        <img
                          src={preview.preview}
                          alt={`Preview ${index}`}
                          width="120"
                          height="120"
                          style={{ borderRadius: '5%' }}
                        />
                      </div>
                      <p style={{ textAlign: 'center', paddingTop: '20px' }}>
                        {trimText(preview.name, 15)}
                      </p>
                    </div>
                  ) : (
                    <div>
                      <img
                        src={preview.preview}
                        alt={`Preview ${index}`}
                        width="160"
                        height="160"
                        style={{ borderRadius: '5%' }}
                      />
                      <p style={{ textAlign: 'center' }}>
                        {trimText(preview.name, 15)}
                      </p>
                    </div>
                  )}
                  <button
                    style={{
                      position: 'absolute',
                      top: '0',
                      right: '0',
                      backgroundColor: '#000',
                      color: '#fff',
                      padding: '4px',
                      borderRadius: '50%',
                      border: 'none',
                      cursor: 'pointer',
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop: '-0.1px', // Adjust the button's top margin to move it more to the upper right corner
                      marginRight: '-0.1px', // Adjust the button's right margin to move it more to the upper right corner
                    }}
                    onClick={() => handleImageRemove(index)}
                  >
                    x
                  </button>
                </div>
              ))}
            </div>
            <h2 htmlFor="address">Location of Requests</h2>
            <label>
              <span class="name-label">Address </span>
              <span class="required-asterisk">*</span>
            </label>
            <input
              type="text"
              id="address"
              name="address"
              required
              ref={addressInputRef}
            />
            {showMap && (
              <RequestLocation
                mapRef={mapRef}
                addressInputRef={addressInputRef}
              />
            )}
            <input type="hidden" id="latitude" name="latitude" />
            <input type="hidden" id="longitude" name="longitude" />
            <div className="button-container">
              <div className="submit-button-wrapper">
                <input
                  type="hidden"
                  id="re-token"
                  name="re-token"
                  value={captchaToken}
                />
                <Reaptcha
                  sitekey={catpchaKey}
                  ref={captchaRef}
                  onVerify={verify}
                  onExpire={onExpire}
                />
                <span
                  id="error_message"
                  style={{ color: 'red', visibility: 'hidden' }}
                >
                  Please enter valid captcha
                </span>

                <input
                  type="submit"
                  id="submitButton"
                  style={{ background: bgColor, marginTop: '18px' }}
                  value={
                    isLoading
                      ? 'Loading...'
                      : isSubmitted
                      ? 'Submitted'
                      : 'Submit'
                  }
                  disabled={isSubmitDisabled || isLoading || isSubmitted}
                  className={isSubmitted ? 'submitted' : ''}
                />
              </div>
            </div>
            <br />
            <br />
            <div>
              {
                <img
                  className="rightimg"
                  alt="Cohesis_logo"
                  src="/Cohesis_logo.svg"
                />
              }
            </div>
          </form>
        )}
      </div>
    </>
  );
};

export default MyForm;
